// GET /v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)

import axios from "../../../../api/axiosSetup3";

/* 
SELECT 
	s.*, 
	e.name,
	g.name,
	sub.name
FROM v_event_last_summary s
JOIN lpr_group g USING(customer_id, group_id)
LEFT JOIN lpr_subtenant sub USING(customer_id, subtenant_id)
JOIN lpr_entity e USING(entity_id)
WHERE s.customer_id = 256
*/

const getEventLastSummary_ = async (): Promise<any[]> => {
    const res = await axios.get<any[]>('/v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)');
    return res.data;
};

// 1. Описываем интерфейс исходного ответа от PostgREST
interface PostgrestEventResponse {
  id: number;
  cnt_enter: number;
  cnt_exit: number;
  difffact: number;
  lpr_group: { name: string } | null;
  lpr_subtenant: { name: string } | null;
  lpr_entity: { name: string } | null;
}

// 2. Описываем интерфейс целевой (плоской) таблицы
export interface FlatEventSummary {
  id: number;
  cnt_enter: number;
  cnt_exit: number;
  difffact: number;
  lpr_group_name: string | null;
  lpr_subtenant_name: string | null;
  lpr_entity_name: string | null;
}

export interface Event {
  id: number;
  ts_start: string;
  lpr_entity_name: string;
  lpr_group_name: string;
  lpr_subtenant_name: string | null;
  registration_number: string;
  matched_number: string | null;
  verified_number: string | null;
  car_brand: string;
  car_owmer: string;
  group_id: number;
  entity_id: number;
  entity_id_1: number;
  entity_id_3: number;
  subtenant_id: number | null;
  tag: string;
}

async function getEventLastSummary(): Promise<FlatEventSummary[]> {
  const res = await axios.get<PostgrestEventResponse[]>(
    '/v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)'
  );

  return res.data.map(({ lpr_group, lpr_subtenant, lpr_entity, ...item }) => ({
    ...item,
    lpr_group_name: lpr_group?.name ?? null,
    lpr_subtenant_name: lpr_subtenant?.name ?? null,
    lpr_entity_name: lpr_entity?.name ?? null,
  }));
}

async function getEventLastIn( params : { moment: string, period_days: number }  ): Promise<Event[]> {
    const res = await axios.get<Event[]>(`/rpc/sf_event_last_in_2?moment=${params.moment}&period_days=${params.period_days}`, );
    return res.data;
}

async function getEstimateVeh__(): Promise<Event[]> {
    const res = await axios.get<Event[]>(`/lpr_present`, );
    return res.data;
}

export interface EventExt extends Event {
  // [key: string]: string | number | boolean | null | undefined;
  plate_tag?: string;
}

async function getEstimateVeh(): Promise<EventExt[]> {
    // const res = await axios.get<EventExt[]>(`/lpr_present?select=*,...lpr_plate(car_owner,car_brand,group_id,plate_tag:tag)`, );
    const res = await axios.get<EventExt[]>('/v_present', );
    return res.data;
}

async function deleteEstimateVeh(customerId: number, registration_number: string): Promise<boolean> {
    const res = await axios.delete(`/lpr_present?customer_id=eq.${customerId}&registration_number=eq.${registration_number}`,
      {
        headers: {
          'Prefer': 'return=representation'
        }        
      }
    );
    return res.status == 200 && res.data.length > 0;
}

async function addEstimateVeh(event: Event, customer_id: number): Promise<Event> {
  const           { entity_id, entity_id_1, registration_number, ts_start, tag, } = event;
  const payload = { entity_id, entity_id_1, registration_number, ts_start, tag, customer_id, uuid: 'uuid' };
  const res = await axios.post<number>('/lpr_present', payload);
  return event;
}

async function getAnyEntity(param: {customerId: number, type: number}): Promise<number> {
  const res = await axios.get<Event[]>(`/lpr_entity?customer_id=eq.${param.customerId}&type=eq.${param.type}`);
  return res.data.length > 0 ? res.data[0].entity_id : -1;
}

export const reportApi = {
    getEventLastSummary,
    getEventLastIn,
    getEstimateVeh,
    deleteEstimateVeh,
    addEstimateVeh,
    getAnyEntity,
};